import { getIdentityProviderDataAttribute, isEntraExternalIdAttribute } from './identity-provider'
import { MSalConfig as MSalBaseTestConfig } from './msal-configs/base/msal-config-test'
import { MSalProdConfig } from './msal-configs/base/msal-config-prod'
import { MSalEntraNaProdConfig } from './msal-configs/base/msal-config-entra-na-prod'
import { MSalEntraNaTestConfig } from './msal-configs/base/msal-config-entra-na-test'
import { MSalConfig as MSalUsNonMainTestConfig } from './msal-configs/us-non-main/msal-config-test'
import { MSalUsNonMainEntraTestConfig } from './msal-configs/us-non-main/msal-config-entra-na-test'
import { MSalCanadaTestConfig } from './msal-configs/canada/canada-test'
import { MSalCanadaProdConfig } from './msal-configs/canada/canada-prod'
import { MSalCanadaEntraTestConfig } from './msal-configs/canada/canada-entra-test'
import { MSalCanadaEntraProdConfig } from './msal-configs/canada/canada-entra-prod'
import { MSalMexicoTestConfig } from './msal-configs/mexico/mexico-test'
import { MSalMexicoProdConfig } from './msal-configs/mexico/mexico-prod'
import { MSalMexicoEntraTestConfig } from './msal-configs/mexico/mexico-entra-test'
import { MSalMexicoEntraProdConfig } from './msal-configs/mexico/mexico-entra-prod'

export type NaMsalAuthConstants = {
	tenant: string
	authority: string
	policy: string
	clientID: string
	approvedAuthorities: string[]
}

function useNaEntraMsal(): boolean {
	return isEntraExternalIdAttribute(getIdentityProviderDataAttribute())
}

/** US main (base MSAL modules): UnitedStatesConfig, ChevyEvConfig. */
export function resolveUsMainMsal(): NaMsalAuthConstants {
	const entra = useNaEntraMsal()
	if (PROD_BUILD) {
		return entra ? MSalEntraNaProdConfig : MSalProdConfig
	}
	return entra ? MSalEntraNaTestConfig : MSalBaseTestConfig
}

/** US non-main test client differs from main; prod still uses base prod constants. */
export function resolveUsNonMainMsal(): NaMsalAuthConstants {
	const entra = useNaEntraMsal()
	if (PROD_BUILD) {
		return entra ? MSalEntraNaProdConfig : MSalProdConfig
	}
	return entra ? MSalUsNonMainEntraTestConfig : MSalUsNonMainTestConfig
}

export function resolveCanadaMsal(): NaMsalAuthConstants {
	const entra = useNaEntraMsal()
	if (PROD_BUILD) {
		return entra ? MSalCanadaEntraProdConfig : MSalCanadaProdConfig
	}
	return entra ? MSalCanadaEntraTestConfig : MSalCanadaTestConfig
}

export function resolveMexicoMsal(): NaMsalAuthConstants {
	const entra = useNaEntraMsal()
	if (PROD_BUILD) {
		return entra ? MSalMexicoEntraProdConfig : MSalMexicoProdConfig
	}
	return entra ? MSalMexicoEntraTestConfig : MSalMexicoTestConfig
}
